import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "./BaseController";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import { ErrorHandler } from "../service/ErrorHandler.service";
import { GeburtstagsKontakt } from "../model/models";
import { EnvironmentService } from "../service/Environment.service";
import { Link$PressEvent } from "sap/m/Link";
import { URLHelper } from "sap/m/library";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class BirthdayList extends BaseController {
  private _oModel: JSONModel;

  override async getTitle(): Promise<string> {
    return "Geburtstage";
  }

  onInit(): void {
    this._oModel = new JSONModel();
    this.setModel(this._oModel);
    this.getRouter().getRoute("birthdayList").attachPatternMatched(this._onPatternMatch);
  }

  private _onPatternMatch = async (oEvent: Route$PatternMatchedEvent) => {
    await this._loadBirthdays();
  };

  private _loadBirthdays = async () => {
    this._oModel.setProperty("/busy", true);

    try {
      const birthdays: Array<GeburtstagsKontakt> = await $.getJSON(`${EnvironmentService.getBaseUrl()}/kontakte/geburtstage`);
      this._oModel.setProperty("/items", birthdays);
    } catch (ex: any) {
      ErrorHandler.handleError(ex, {
        title: "Fehler beim Laden der Geburtstage",
        onAbort: () => this.getOwnerComponent().getRouter().navTo("home"),
        onRetry: () => this._loadBirthdays(),
      });
    } finally {
      this._oModel.setProperty("/busy", false);
    }
  };

  handlePhonePress = (oEvent: Link$PressEvent) => {
    URLHelper.triggerTel(oEvent.getSource().getText());
  };

  handleEmailPress = (oEvent: Link$PressEvent) => {
    URLHelper.triggerEmail(oEvent.getSource().getText());
  };

  handleFirmenNamePress = (oEvent: Link$PressEvent) => {
    const oBindingContext = oEvent.getSource().getBindingContext();
    const oModel = oBindingContext.getModel() as JSONModel;
    const oData: GeburtstagsKontakt = oModel.getProperty(oBindingContext.getPath());

    this.getOwnerComponent().getRouter().navTo("customersDetails", { idPath: oData.kundeId, lfdPath: oData.kundeLfd });
  };
}
